
  import { useWindowMessage } from '@/ui/concerns/useWindowMessage';
  import { defineComponent, ref, watch } from 'vue';
  import { Modal } from '@/ui/components/Modal';
  import { iosLink, androidLink } from '@/ui/helpers';
  import { Button } from '@/ui/components/Button';
  import { Userflow, UserflowTrackEvent, UserflowTriggers } from '@/services/userflow/userflow';
  import { MOBILE_APP_POPUP_MODAL_WIDTH } from '@/ui/components/modals/constants';

  export default defineComponent({
    components: {
      Modal,
      Button,
    },
    setup() {
      const showMobileAppPopupModal = ref(false);
      const hideModal = () => {
        showMobileAppPopupModal.value = false;
      };

      useWindowMessage(UserflowTriggers.MOBILE_APP_POPUP, () => {
        showMobileAppPopupModal.value = true;
      });

      watch(showMobileAppPopupModal, value => {
        if (value) {
          Userflow.trackEvent(UserflowTrackEvent.APP_INSTALLED);
        }
      });

      return {
        hideModal,
        showMobileAppPopupModal,
        iosLink,
        androidLink,
        MOBILE_APP_POPUP_MODAL_WIDTH,
      };
    },
  });
